import { render, staticRenderFns } from "./sampleDocuments.vue?vue&type=template&id=71aecefa&scoped=true&"
import script from "./sampleDocuments.vue?vue&type=script&lang=js&"
export * from "./sampleDocuments.vue?vue&type=script&lang=js&"
import style0 from "./sampleDocuments.vue?vue&type=style&index=0&id=71aecefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aecefa",
  null
  
)

export default component.exports